"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "@/lib/navigation";

export const useLastPage = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    let active = true;

    try {
      const ignoredPages = [
        "/auth/login",
        "/auth/register",
        "/auth/refresh",
        "/auth/forgot-password/set",
        "/auth/forgot-password/success",
        "/auth/forgot-password",
        // Its `?auth=` carries the signed access + refresh token blob (PMO-153).
        "/auth/sso-callback",
      ];

      if (!ignoredPages.includes(pathname)) {
        // Never persist a credential, whatever page it turns up on (PMO-153).
        const query = new URLSearchParams(searchParams?.toString());
        query.delete("auth");
        const params = query.toString();
        const fullUrl = pathname + (params ? `?${params}` : "");
        // last_page is persisted to a varchar(1024) column; a long or nested
        // callback query string can still push the full URL past that limit, so
        // fall back to the bare pathname and skip if even that won't fit.
        const MAX_LAST_PAGE_LENGTH = 1024;
        const lastPage =
          fullUrl.length <= MAX_LAST_PAGE_LENGTH
            ? fullUrl
            : pathname.length <= MAX_LAST_PAGE_LENGTH
              ? pathname
              : null;
        if (lastPage) {
          void import("@/lib/store/auth").then(({ useAuthStore }) => {
            if (active) {
              useAuthStore.getState().storeLastPage(lastPage);
            }
          });
        }
      }
    } catch (error) {
      console.error("Error in useLastPage:", error);
    }

    return () => {
      active = false;
    };
  }, [pathname, searchParams]);
};
